const manifest = [
  {
    id: "01",
    title: "Human Navigation Interface.",
    text: "Navigation darf sich nicht wie ein Werkzeug anfühlen —sie soll sich anfühlen wie eine Begegnung.",
  },
  {
    id: "02",
    title: "Ich gebe Raum – für Gedanken, nicht für Lärm.",
    text: "Raum zum Lesen. Raum zum Denken. Raum, um zu atmen. Meine Seite schreit nicht. Sie flüstert. Und wer zuhört, findet Tiefe."
  },
  {
    id: "03",
    title: "Ich lade ein – ich führe nicht.",
    text: "Ein Button ist für mich keine Anweisung. Ein Textfeld kein Zwang. Ich frage: ‚Magst du …‘ – nicht: ‚Jetzt hier klicken!‘"
  },
  {
    id: "04",
    title: "Ich reduziere, aber nehme nichts weg.",
    text: "Ich entferne, was stört. Nicht, was trägt. Was bleibt, ist das Wesentliche: Inhalt. Struktur. Menschlichkeit."
  },
  {
    id: "05",
    title: "Ich verbinde Digitales mit dem Echten.",
    text: "Meine Schrift erinnert an Schreibmaschinen. Meine Bilder sind gezeichnet, nicht gerendert. Technologie soll nicht ersetzen – sie soll begleiten."
  },
  {
    id: "06",
    title: "Ich vertraue dir mehr als jedem Call-to-Action.",
    text: "Ich glaube nicht, dass man Menschen überreden muss. Ich gebe dir Raum, selbst zu wollen. Deshalb sage ich: ‚Finde deinen Weg.‘ Nicht: ‚so geht das!‘"
  },
  {
    id: "07",
    title: "Ich gestalte für Beziehung – nicht für Klicks.",
    text: "Ästhetik ist für mich keine Mode, sondern eine Haltung. Würde ist die schönste Benutzeroberfläche, die ich gestalten kann."
  },
  {
    id: "08",
    title: "Ich höre zu – nicht nur hin.",
    text: "Ich nehme mir Zeit für Feedback, für Empathie und für das, was zwischen den Zeilen steht. So entsteht echtes Verständnis."
  },
  {
    id: "09",
    title: "Ich achte auf Details – nicht aus Perfektionismus.",
    text: "Jede Linie zählt. Jede Farbe hat Bedeutung. Aber nicht um der Kunst willen, sondern um der Klarheit willen."
  },
  {
    id: "10",
    title: "Ich bin zugänglich – nicht exklusiv.",
    text: "Meine Seiten sind für alle da: barrierefrei, verständlich, inklusiv. Design ist nur dann gut, wenn jeder teilhaben kann."
  },
  {
    id: "11",
    title: "Ich sorge für Nachhaltigkeit – nicht für Eintagsfliegen.",
    text: "Ich denke langfristig: sauberen, wartbaren Code, ökologische Verantwortung im Hosting, damit meine Arbeit Bestand hat."
  },
];

export default manifest;
